import { FEATURES } from 'shared/app/components/optimizely/optimizely-keys';
import { getOptimizelyDecision } from 'shared/app/components/optimizely/get-optimizely-decision';

export const getDemystifyMenuFeatureFlag = () =>
  getOptimizelyDecision(FEATURES.DEMYSTIFY_MENU_PDP);

export const getDemystifyPreviousFeatureFlag = () =>
  getOptimizelyDecision(FEATURES.DEMYSTIFY_PREVIOUS_FAVORITES);

export const getDemystifyFavoritesFeatureFlag = () =>
  getOptimizelyDecision(FEATURES.DEMYSTIFY_PREVIOUS_FAVORITES);
